export enum Role {
  UNDEFINED = -1,
  MEMBER = -2,
  ADMIN = -3,
  SUPER_ADMIN = -4,
}
